import styled from 'styled-components';
import { Grid } from 'components/ui';
import theme from 'theme';

export const Form = styled.form`
  margin-bottom: 20px;
`;

export const WideForm = styled.form`
  margin-bottom: 20px;
  min-width: ${theme.width.formMin};
  max-width: ${theme.width.form};
  width: 100%;
  & > *:not(:last-child) {
    margin-bottom: ${theme.padding.content};
}
`;

export const DrawerForm = styled.form`
  padding: 0 20px;
  margin: 20px auto;
  min-width: ${theme.width.formMin};
  max-width: ${theme.width.filterDrawer};
  width: 100vw;
`;

export const WideFormGrid = styled(Grid)`
  max-width: ${theme.width.form};
`;
